<template>
  <div id="app">
    <headerMenu />
    <categoriesNav :categories="categoriesList" />
    <div class="py-8 bg-gray-100">
      <dishCategory
        v-for="(menu, index) in filteredMenus"
        :key="index"
        :title="menu.category"
        :description="menu.description"
        :emoji="menu.emoji"
      >
        <dishItem
          v-for="(menu, index) in menu.menus"
          :key="index"
          :title="menu.title"
          :description="menu.description"
          :price="menu.price"
          :newProduct="menu.is_new"
          :covid_price="menu.covid_price"
          :imgUrl="menu.img_url"
        ></dishItem>
      </dishCategory>
    </div>
  </div>
</template>

<script>
import headerMenu from "@/components/headerMenu"
import categoriesNav from "@/components/categoriesNav"
import dishItem from "@/components/dishItem"
import dishCategory from "@/components/dishCategory"
import menus from "@/assets/json/menus_240720.json"
import categories from "@/assets/json/categories.json"

export default {
  name: "App",
  data: function() {
    return {
      menus,
      categories,
    }
  },
  components: {
    dishItem,
    dishCategory,
    headerMenu,
    categoriesNav,
  },
  computed: {
    categoriesList() {
      let categoriesLists = []
      let categories = this.menus.map((menu) => menu.category)
      let filteredCategories = categories.filter(
        (v, i) => categories.indexOf(v) === i
      )
      filteredCategories.forEach((category) => {
        if (category != "") {
          categoriesLists.push(category)
        }
      })
      return categoriesLists
    },
    filteredMenus() {
      let filteredMenus = []
      this.categoriesList.forEach((category) => {
        if (category != "") {
          filteredMenus.push({category: category, menus: []})
        }
      })

      this.categories.forEach((category) => {
        filteredMenus.forEach((f) => {
          if (f.category === category.name) {
            f.description = category.description
            f.emoji = category.emoji
          }
        })
      })

      this.menus.forEach((menu) => {
        filteredMenus.forEach((f) => {
          if (f.category === menu.category) {
            f.menus.push(menu)
          }
        })
      })
      return filteredMenus
    },
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
